import {ICRSOutline} from "../interfaces";
import {groupBy, orderBy} from "lodash";

export const  GrouAndSortOutlineList = (outlineList : ICRSOutline[]) => {

    let grouped1 = orderBy(outlineList , 'unitNumber');
    let grouped = groupBy(grouped1 , 'unitNumber');
    return grouped;

}

export const  IsVisibleBoxOutline = () => {
    let IsVisible = true;
    let metaTag =  document.getElementsByName('guid');//[0].getAttribute('content')
    let  metaValue = null;
    if(metaTag && metaTag[0]) {
        metaValue = metaTag[0].getAttribute('content');
        if (metaValue === '310f6489-d432-4a5a-8a2f-a4dc7d773200')//WavesMixingFoundations /*courses/waves-mixing-foundations*/
            IsVisible = false;
    }
    //console.log('IsVisibleCorseImportantSection: ',metaValue);
    return IsVisible;
}
export const  GetH1 = () => {
    let h1 =  document.getElementsByTagName('h1');
    let  h1Value = null;
    if(h1 && h1[0]) {
        h1Value = h1[0].innerText;

    }
    return h1Value;
}
